import React from 'react';
import { NextPage } from 'next';
import TeacherTeamDevelopmentStrategyTemplate from '@components/TeacherTeamDevelopmentStrategy/TeacherTeamDevelopmentStrategy';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';

interface ITeacherTeamDevelopmentStrategy {}

const TeacherTeamDevelopmentStrategy: NextPage<ITeacherTeamDevelopmentStrategy> = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <TeacherTeamDevelopmentStrategyTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default TeacherTeamDevelopmentStrategy;
